import { type I18n } from '../../types/i18n.types';
import {
  type AppNamespace,
  type AppTranslationPaths,
  type CommonPaths,
  type CustomerTranslatedObject,
  type TranslateFunction,
} from '../AutoneTranslationContext.types';

export const createAutoneTranslationFunction = <Paths extends string>(
  i18n: I18n,
  namespace: string,
  customerSlug?: string | null,
) => {
  const i18nTranslationFunction = i18n.getFixedT(null, namespace);
  const autoneTranslationFunction =
    i18nTranslationFunction as unknown as TranslateFunction<Paths>;

  autoneTranslationFunction.withValue = (key, options) => {
    return autoneTranslationFunction(key, {
      ...options,
      context: 'value',
    });
  };

  autoneTranslationFunction.withCustomer = (key, options) => {
    const translationObject = i18nTranslationFunction(key, {
      ...options,
      returnObjects: true,
    }) as CustomerTranslatedObject;

    if (!customerSlug || !(customerSlug in translationObject)) {
      return translationObject.default as string;
    }

    return translationObject[customerSlug] as string;
  };

  return autoneTranslationFunction;
};

export const getTranslationFunctions = <NS extends AppNamespace>(
  i18n: I18n,
  namespace: NS,
  customerSlug?: string | null,
) => {
  type Paths = AppTranslationPaths[NS];

  const t = createAutoneTranslationFunction<Paths>(
    i18n,
    namespace,
    customerSlug,
  );
  const common = createAutoneTranslationFunction<CommonPaths>(
    i18n,
    'common',
    customerSlug,
  );

  return {
    t,
    common,
  };
};
